import { Button, Col, Table, Container, Form, Row, ButtonGroup, Stack, InputGroup, ToggleButton, ToggleButtonGroup, Card } from "react-bootstrap";
import womanData from "../assets/womanData.svg";

const VirtualAssitant = () => {
    return (
        <Container fluid className="p-4">
            <Row>
                <Col className="bg-white p-4 h-100">
                    <h1 className="text-uppercase text-center text-xl-start">Virtual Assistant</h1>
                </Col>
            </Row>
            <hr />
            <Row className="bg-white p-4">
                <h1 className="text-uppercase text-center pb-4">COMING SOON!</h1>
                <Row className="row-name d-flex flex-column flex-xl-row">
                    <div className="col-12 col-xl-6 order-1 order-xl-2  text-center text-xl-start">
                        <h5>
                            <p>Bigger, Better, and Smarter.</p>
                            <p>
                                Like the rest of the new RadioAnalyzer, we’ve sent Email Reports R&D lab for update and an upgrade. Later this year we will be
                                releasing the Virtual Assistant.
                            </p>
                            <p>
                                A tailor-made, customizable reporting and alert system to help you get vital and timely updates on your station performance and
                                market surveillance.
                            </p>
                        </h5>
                    </div>
                    <div className="col-12 col-xl-6 order-2 order-xl-1">
                        <img src={womanData} alt="woman data" height={350} className="w-100" />
                    </div>
                </Row>
            </Row>
        </Container>
    );
};

export default VirtualAssitant;
